import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

type Resources = Record<'name', string>;

type FunnelParams = {
    resources: Array<Resources>;
    gcsFileName: string;
};

export default {
    name: 'funnel-csv',
    productArea: PRODUCT_AREAS.ANALYTICS,
    subProductArea: SUB_PRODUCT_AREAS.FUNNELS,
    response: ({ resources, gcsFileName }: FunnelParams) => ({
        location: 'gcs',
        mimeType: 'text/csv',
        name: `${gcsFileName}.csv`,
        fields: [
            { field: 'visitorId', label: 'Visitor ID' },
            { field: 'steps', label: '# Steps completed' },
            ...resources.map((resource, i) => ({
                field: `step${i + 1}`,
                label: `Timestamp Step ${i + 1}: ${resource.name}`,
            })),
        ],
    }),
    build: ({ gcsFileName, resources }: FunnelParams) => {
        return o.pipeline(
            {
                source: {
                    gcs: gcsFileName,
                },
            },
            o.filter('!isNil(visitorId)'),
            o.select({
                visitorId: 'visitorId',
                steps: 'steps',
                ...resources.reduce((map: Record<string, string>, _resource, i) => {
                    map[`step${i + 1}`] = `formatTime("2006-01-02 15:04:05",times[${i}])`;

                    return map;
                }, {}),
            }),
            o.sort('visitorId'),
        );
    },
};
